import { Eye, Icon } from "@norican/icons";
import { Button, cn } from "@norican/react";
import { useNavigate } from "react-router";

import { ErrorState } from "@/components/common";
import { useT } from "@/i18n";
import { useMe } from "@/lib/api";

import { useStartViewAs } from "./api";
import { mayOfferViewAs } from "./view-as-state";

/**
 * "View as this person" (6 Oct): starts a read-only view and opens their My
 * Tickets. Renders nothing unless the reader may (an admin on VIEW_AS_EMAILS).
 */
export function ViewAsButton({
  employeeId,
  className,
}: {
  employeeId: string;
  className?: string;
}) {
  const { t } = useT();
  const { data: me } = useMe();
  const start = useStartViewAs();
  const navigate = useNavigate();

  if (!mayOfferViewAs(me) || employeeId === "") {
    return null;
  }
  return (
    <div className={cn("flex flex-col gap-2", className)}>
      <div>
        <Button
          variant="outline"
          tone="neutral"
          size="sm"
          startIcon={<Icon icon={Eye} size="sm" />}
          disabled={start.isPending}
          onClick={() => start.mutate(employeeId, { onSuccess: () => void navigate("/tickets") })}
        >
          {start.isPending ? t("viewAs.page.starting") : t("viewAs.button")}
        </Button>
      </div>
      {start.isError ? (
        <ErrorState variant="inline" error={start.error} title={t("viewAs.page.failed")} />
      ) : null}
    </div>
  );
}
